import { t } from "@lingui/macro";
import { ResumeDto } from "@reactive-resume/dto";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { LoaderFunction, redirect } from "react-router-dom";

import { queryClient } from "@/client/libs/query-client";
import { findResumeById } from "@/client/services/resume";
import { useBuilderStore } from "@/client/stores/builder";
import { useOpenAiStore } from "@/client/stores/openai";
import { useResumeStore } from "@/client/stores/resume";

export const BuilderPage = () => {
  const frameRef = useBuilderStore((state) => state.frame.ref);
  const setFrameRef = useBuilderStore((state) => state.frame.setRef);

  const resume = useResumeStore((state) => state.resume);
  const title = useResumeStore((state) => state.resume.title);

  const { setApiKey, setBaseURL, setModel } = useOpenAiStore();

  const updateResumeInFrame = () => {
    if (!frameRef?.contentWindow) return;
    const message = { type: "SET_RESUME", payload: resume.data };
    frameRef.contentWindow.postMessage(message, "*");

    const parentMessage = { type: "SAVE_TO_DB", payload: resume.data };
    window.parent.postMessage(parentMessage, "*");
  };

  // Send resume data to iframe on initial load
  const handleParentMessage = (event: MessageEvent) => {
    if (event.data.type === "INIT_SUB_OPENAI") {
      const payload = event.data.payload;
      const openai = payload;
      setApiKey(openai.apiKey);
      setBaseURL(`${openai.baseUrl}/v1`);
      setModel(openai.modelName);
    }
  };

  useEffect(() => {
    if (!frameRef) return;
    // Listen for messages from parent window

    const initData = { type: "INIT_SUB_OPENAI" };
    window.parent.postMessage(initData, "*");

    window.addEventListener("message", handleParentMessage);
    frameRef.addEventListener("load", updateResumeInFrame);
    return () => {
      window.removeEventListener("message", handleParentMessage);
      frameRef.removeEventListener("load", updateResumeInFrame);
    };
  }, [frameRef]);

  // Send resume data to iframe on change of resume data
  useEffect(updateResumeInFrame, [resume.data]);

  return (
    <>
      <Helmet>
        <title>
          {title} - {t`Reactive Resume`}
        </title>
      </Helmet>

      <iframe
        ref={setFrameRef}
        title={resume.id}
        src="/artboard/builder"
        className="mt-16 w-screen"
        style={{ height: `calc(100vh - 64px)` }}
      />
    </>
  );
};

export const builderLoader: LoaderFunction<ResumeDto> = async ({ params }) => {
  let result: ResumeDto | null = null;
  window.addEventListener("message", (event) => {
    if (event.data.type === "INIT_SUB") {
      result = event.data.payload;
      if (!result) {
        return;
      }
      useResumeStore.setState({ resume: result });
      useResumeStore.temporal.getState().clear();
    }
  });
  const promise = new Promise<ResumeDto>((resolve) => {
    const initData = { type: "INIT" };
    window.parent.postMessage(initData, "*");
    resolve({} as ResumeDto);
  });
  await promise;

  return result;
  // const result = await promise;
  // return result
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const id = params.id!;

    const resume = await queryClient.fetchQuery({
      queryKey: ["resume", { id }],
      queryFn: () => findResumeById({ id }),
    });

    useResumeStore.setState({ resume });
    useResumeStore.temporal.getState().clear();

    return resume;
  } catch {
    return redirect("/dashboard");
  }
};
